module.exports = __webpack_public_path__ + "static/bdmyshopifull-7fb5a38601f25426eb3b5b0cf8b36484.jpg";